import {
  Button,
  CloseButton,
  ListContext,
  ListContextValue,
  Stack,
  Typography,
  ValidationErrors,
  newToast,
} from "@compass/core";
import { SubmitButton } from "components";
import { Student } from "generated/openApi";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";
import { studentPageRoute } from "../StudentPage/StudentPage";

export const StudentPageHeader = (props: {
  handle: string;
  student: Student;
  setValidationErrors: (errors: ValidationErrors) => void;
  unsavedChanges: boolean;
  step: number;
  setStep: (value: number) => void;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const listContext = useContext<ListContextValue>(ListContext);

  const proceedToStep2 = (student: Student) => {
    ApiService.students
      .saveCreateValidate(student, 1)
      .then(() => {
        props.setStep(2);
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
        props.setValidationErrors(ex.data);
      });
  };

  const save = (student: Student) => {
    props.setValidationErrors({});

    ApiService.students
      .saveCreate(student)
      .then((response) => {
        const id = response;
        navigate(`../${studentPageRoute.getPath({ id: id, crudMode: "view" })}`);
        listContext.loadList?.();
        dispatch(setAppToast(newToast("success")));
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
        props.setValidationErrors(ex.data);
      });
  };

  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">{props.handle}</Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        <CloseButton confirm={props.unsavedChanges} />

        {props.step === 1 && (
          <SubmitButton onClick={() => proceedToStep2(props.student)} label="Next" variant="outlined" />
        )}

        {props.step === 2 && (
          <>
            <Button onClick={() => props.setStep(props.step - 1)} variant="outlined">
              Back
            </Button>

            <SubmitButton
              onClick={() => save(props.student)}
              disabled={props.student.id > 0 && !props.unsavedChanges}
            />
          </>
        )}
      </Stack>
    </Stack>
  );
};
